// Axios
import Axios from "./axios"

export const addAcademyWorkshop = (value) => {
    return new Promise((resolve, reject) => {
        const data = Axios.post(`/academyworkshop/create`, value, {
            headers: {
                'access-token': localStorage.getItem("access_token")
            }
        })
        resolve(data)
    })

}